"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var logger_1 = require("../../../../experiences/pharmacy-pricing-experience/logging/logger");

var error_context_1 = require("../../../../theming/pricing-system/error-context");

var error_panel_1 = require("../error-panel/error-panel");

var ErrorBoundary = function (_super) {
  __extends(ErrorBoundary, _super);

  function ErrorBoundary() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      hasError: false
    };
    return _this;
  }

  ErrorBoundary.prototype.componentDidCatch = function (error) {
    this.setState({
      hasError: true
    });

    try {
      logger_1.Logger.logException(error);
    } catch (_a) {
      console.error("Failed to log exception -- " + error.message);
    }
  };

  ErrorBoundary.prototype.render = function () {
    if (this.state.hasError) {
      return react_1.default.createElement(error_panel_1.ErrorPanel, {
        contextId: error_context_1.ErrorContext.boundary
      });
    }

    return this.props.children;
  };

  return ErrorBoundary;
}(react_1.default.Component);

exports.ErrorBoundary = ErrorBoundary;